  import { createReducer } from "redux-act";
  import {getFilteredReportListSuccessful, getFilteredReportListFailure} from "../actions/report"
  const DEFAULT_USER = {
    reportList:[],
  };
  
  export default createReducer(
    {
      [getFilteredReportListSuccessful] : (state, payload) => {
        return {
          ...state,
          reportList: payload,
        };
      }      
  
    },
    DEFAULT_USER
  );
  